export default "__VITE_ASSET__CGinfPbi__"